import { handleActions } from 'redux-actions'
import update from 'immutability-helper'
import * as actions from './labelPublish.actions'

const initialState = {
    rootList: [],
    getlabelInfoLoading: false,
    user: { bizdate: '--', num: 0 },
}

export type LabelPublishState = {
    rootList: any[],
    getlabelInfoLoading: boolean,
    user: any,
}

export default handleActions<LabelPublishState>({
    [actions.RECEIVE_ROOT_LIST_DATA]: (state: any, { payload }) => {
        return update(state, {
            rootList: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.GET_LABEL_INFO_LOADING]: (state, {payload}) =>{
        return update(state, {
            getlabelInfoLoading: {$set: (payload as any)}
        })
    },
    [actions.RECEIVE_USER_NUM]: (state, {payload}) =>{
        return update(state, {
            user: {$set: (payload as any)}
        })
    },
}, initialState)
